"use client";

import type { FC } from "react";
import { useSearchModal } from "../hooks/useSearchModal";
import type { GameFragment, SelectedProvider } from "../types";
import SearchModal from "./SearchModal";

type Props = {
  locale?: string;
  brand?: string;
  countryCode?: string;
};

const SearchWidget: FC<Props> = ({ locale = "en", brand, countryCode }) => {
  const {
    currentState,
    toggle,
    loadMoreAvailable,
    searchTerm,
    currentSearchTerm,
    loadMore,
    loading,
    surpriseMeFunc,
    currentVisibleItems,
    totalSearchItems,
    setCategory,
    toggleProvider,
    currentSelectedProviders,
    allProviders,
  } = useSearchModal(brand, countryCode);

  const isSearchView =
    currentSearchTerm !== "" || currentSelectedProviders.length > 0;

  const selectedProviders: SelectedProvider[] = currentSelectedProviders.map(
    (name) => ({ handle: name, name }),
  );

  const handleToggleProvider = (provider: SelectedProvider) => {
    toggleProvider(provider.name);
  };

  return (
    <SearchModal
      locale={locale}
      open={currentState}
      onOpenChange={toggle}
      onCategoryChange={setCategory}
      isLoading={loading && isSearchView}
      onSearch={searchTerm}
      isSearchView={isSearchView}
      games={currentVisibleItems as GameFragment[]}
      totalSearchResultsCount={totalSearchItems}
      onLoadMore={loadMore}
      hasMore={loadMoreAvailable}
      onSurpriseMe={surpriseMeFunc}
      toggleProvider={handleToggleProvider}
      currentSelectedProviders={selectedProviders}
      allProviders={allProviders}
    />
  );
};

export { SearchWidget };
